import { LoadSpinCommand } from "slotworks/commands/comms/load-spin-command";
import { StartSpinCommand } from "slotworks/commands/comms/start-spin-command";
import Components from "slotworks/components/components";
import BetModel from "slotworks/model/bets/bet-model";
import GameState from "slotworks/model/game-state";
import SmartButton from "slotworks/smart-button/smart-button";
import { SmartButtonFlag } from "slotworks/smart-button/smart-button";
import State from "slotworks/state-machine/states/state";
import { parallel } from "slotworks/utils/race-utils";
import CampaignsModel from "slotworks/integration/revolver/model/campaigns-model";
import settingsModel, { Jurisdiction } from "slotworks/model/settings/settings-model";
import Timer from "slotworks/utils/timer";
import Regulation from "slotworks/integration/revolver/regulations/regulation";

export default class RequestSpin extends State {
    public static WINNINGS_RESET_DELAY: number = 1500;

    private skipping: boolean;

    public onEnter(cascadeSkip?: boolean) {

        this.skipping = cascadeSkip;

        this.newGame();

        if(!CampaignsModel.isFreespinsActive()){
            SmartButton.setFlag(SmartButtonFlag.AWAITING_RESPONSE, true);
        }

        Components.footer.showSpinStart(BetModel.getTotalBet());

        parallel([
            () => StartSpinCommand(),
            () => LoadSpinCommand()
        ]).then(() => {
            if (!GameState.getCurrentGame().getCurrentRecord()) {
                Components.matrix.reset();
                this.error();
            } else {
                GameState.getCurrentGame().totalBet = BetModel.getTotalBet();
                if (this.skipping) {
                    this.skip();
                } else {
                    this.complete();

                }
            }
        });
    }

    public onSkip() {
        this.skipping = true;
    }

    public onExit() {
        if(!CampaignsModel.isFreespinsActive()){
            SmartButton.setFlag(SmartButtonFlag.AWAITING_RESPONSE, false);
        }
    }

    protected newGame() {
        if(CampaignsModel.isFreespinsActive()) {
            GameState.newGame();
        } else {
            GameState.newGame(BetModel.getTotalBet());
        }        
        Regulation.interactionStart();
        Components.betBar.winnings.setDelayedWinnings(0, 0, RequestSpin.WINNINGS_RESET_DELAY);
    }
}



// WEBPACK FOOTER //
// ./~/slotworks/state-machine/standard/states/request-spin.ts